import React from 'react';

const PatientAddProfileNextScreen = () => {
  return <></>;
};

export default PatientAddProfileNextScreen;
